<button
  [type]="type()"
  [disabled]="disabled() || loading()"
  [class]="'mat-' + variant()"
  [color]="color()"
  mat-button
  class="custom-button">
  @if (loading()) {
    <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
  }
  <ng-content></ng-content>
</button>

